/**
 * @flow
 * @author: Vamsi Tallam
 * */

/* eslint-disable no-confusing-arrow */

import styled from 'react-emotion'
import BaseInput from '../../../../commons/BaseInput'
import Colors from '../../../../themes/Colors'
import {
  Typo12CoralTwoDRI,
  Typo13DarkGreyBlueDR
} from '../../../../themes/Fonts/Din2014'
import { mobile } from '../../../../utils/mixins'

export const MainContainer = styled('div')`
  width: 253px;
  height: 39px;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  flex-direction: row;
  justify-content: center;
`

export const CustomInput = styled(BaseInput)`
  background-color: ${Colors.black20};
  width: 100%;
  height: 100%;
  border: solid 1px
    ${props =>
      props.displayError ? Colors.dullRed : 'rgba(255, 255, 255, 0.3)'};
  outline: none;
  font-family: din-2014;
  font-size: 16px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.43;
  padding-left: 1.071em;
  padding-right: 1.071em;
  color: ${Colors.whiteTwo80};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  ':focus': {
    border: none;
    outline: none;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  ':-moz-focusring': {
    border: none;
    outline: none;
    border-color: ${Colors.whiteTwo10};
  }
  ::placeholder {
    color: ${Colors.whiteTwo70};
    line-height: 1.43;
  }

  :-ms-input-placeholder {
    color: ${Colors.whiteTwo70};
    line-height: 1.43;
  }

  ::-ms-input-placeholder {
    color: ${Colors.whiteTwo70};
    line-height: 1.43;
  }
  ::-moz-placeholder {
    color: ${Colors.whiteTwo70};
    line-height: 2.43;
  }
`
export const ErrorText = styled(Typo12CoralTwoDRI)`
  margin-top: 5px;
  line-height: 1.67;
  opacity: 0.8;
  visibility: ${props => (props.displayError ? 'visible' : 'hidden')};
  ${mobile} {
    margin: 5px 0px 5px 0px;
  }
`

export const LabelText = styled(Typo13DarkGreyBlueDR)`
  display: block;
  margin-bottom: 3px;
  color: ${props =>
    props.displayError
      ? Colors.dullRed
      : props.isMobile ? Colors.whiteTwo : undefined};
`

export const IconContainer = styled('div')`
  user-select: none;
  width: 11px;
  height: 100%;
`
export const InputContainer = styled('div')``



// WEBPACK FOOTER //
// ./src/components/ExperimentalMarketing/EnquireNowModal/Input/styledComponents.js